export function getCompany(
  order: uui.domain.client.rm.ExtendedOrderStep,
  companiesMap: Record<string, uui.domain.client.rm.Company>,
  archived: boolean,
) {
  const {
    order: { companyId, archivedData },
  } = order

  const hasZombieCompany = companyId !== null && !companiesMap[companyId]

  return archived
    ? (archivedData?.companyName ?? '')
    : companyId === null || hasZombieCompany
      ? ''
      : (companiesMap[companyId]?.name ?? '')
}
